import { DurabilityTaxonomyProportion } from '../../../../types';
export var list = [
    DurabilityTaxonomyProportion.MIN_TWENTY_FIVE_PERCENT,
    DurabilityTaxonomyProportion.MIN_FIFTY_PERCENT,
    DurabilityTaxonomyProportion.MIN_SEVENTY_FIVE_PERCENT,
    DurabilityTaxonomyProportion.FULL,
];
